// Configuration de l'URL du serveur basée sur les variables d'environnement
const getApiUrl = () => {
  // Utilise la variable d'environnement REACT_APP_API_URL si elle est définie
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Fallback basé sur l'environnement NODE_ENV
  if (process.env.NODE_ENV === 'development') {
    return "http://localhost:8000/";
  } else if (process.env.REACT_APP_ENVIRONMENT === 'preprod') {
    return "https://tanoed-pro.osc-fr1.scalingo.io/";
  } else {
    // Production par défaut
    return "https://cli-back.tanoed.com/";
  }
};

export const url = getApiUrl();
